<template>
  <span class="simbolo" :class="{ 'simbolo-forma': datos.forma }" :style="estilo">
    <v-icon :size="tamanoIcono" :color="datos.forma ? color : 'white'">{{ datos.icono }}</v-icon>
  </span>
</template>

<script>
import { simbolo } from "@/utils/simbolosCategorias";

// Símbolo de una categoría de armarios (forma de color o icono blanco en un círculo de color)
export default {
  name: "SimboloCategoria",
  props: {
    icono: { type: String, default: null },
    color: { type: String, default: "#78909C" },
    tamano: { type: Number, default: 20 },
  },
  computed: {
    datos() {
      return simbolo(this.icono);
    },
    tamanoIcono() {
      return this.datos.forma ? this.tamano : Math.round(this.tamano * 0.62);
    },
    estilo() {
      const base = { width: `${this.tamano}px`, height: `${this.tamano}px` };
      return this.datos.forma ? base : { ...base, backgroundColor: this.color };
    },
  },
};
</script>

<style scoped>
.simbolo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
  line-height: 1;
}
.simbolo:not(.simbolo-forma) {
  border: 1.5px solid white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
}
/* las formas llevan un contorno blanco para verse sobre cualquier plano */
.simbolo-forma .v-icon {
  filter: drop-shadow(0 0 1px white) drop-shadow(0 0 1px white) drop-shadow(0 1px 2px rgba(0, 0, 0, 0.4));
}
</style>
